import { render, staticRenderFns } from "./display_activity.vue?vue&type=template&id=4ce830e3&scoped=true"
import script from "./display_activity.vue?vue&type=script&lang=js"
export * from "./display_activity.vue?vue&type=script&lang=js"
import style0 from "./display_activity.vue?vue&type=style&index=0&id=4ce830e3&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce830e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce830e3')) {
      api.createRecord('4ce830e3', component.options)
    } else {
      api.reload('4ce830e3', component.options)
    }
    module.hot.accept("./display_activity.vue?vue&type=template&id=4ce830e3&scoped=true", function () {
      api.rerender('4ce830e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_detail/components/display_activity.vue"
export default component.exports